import {createSelector} from 'reselect';

export const getAllFontSearchHistory = state =>
  state.font.get('fontSearchHistory');

export const getCategories = state => state.font.get('categories');
export const getPreviousCategory = state =>
  state.font.get('previousFontCategory');

export const getFonts = state => state.font.get('fonts');
export const scrollToFont = state => state.font.get('scrollToFont');

export const getFontSearchAutofillData = state =>
  state.font.get('fontAutofillData');

export const isFontClickedFromDropdown = state =>
  state.font.get('isFontClickedFromDropdown');

export const isFontPopular = state => fontName => {
  const popularFonts = getFonts(state).get('Popular');
  if (popularFonts) {
    return popularFonts.some(font => font.displayName === fontName);
  } else {
    return false;
  }
};

export const getFontSearchHistory = createSelector(
  [getAllFontSearchHistory],
  allFontSearchHistory => {
    return allFontSearchHistory.toArray();
  }
);
